<template id="ComplianceIcon">
  <span v-if="complianceState == -1">
    <span
      v-b-tooltip.hover
      title="Out of Compliance"
      class="fa fa-exclamation"
    />
  </span>
  <span v-else-if="complianceState == 1">
    <span v-b-tooltip.hover title="In Compliance" class="fa fa-check" />
  </span>
  <span v-else>
    <!-- <span v-b-tooltip.hover title="Unchecked" class="fa fa-question" /> -->
    <b>-</b>
  </span>
</template>

<script>
export default {
  name: "ComplianceIcon",
  props: {
    complianceState: Number,
  },
};
</script>
